'use client';

import { enableAnalytics } from "@/lib/analytics";
import AnalyticsConsentBanner from "./AnalyticsConsentBanner";
import { useEffect } from "react";

const handleEnableAnalytics = () => {
    enableAnalytics();
};
export default function Analytics() {
    useEffect(() => {
        const savedPreference = localStorage.getItem('analytics-enabled');
        if (savedPreference === null || savedPreference === 'false') {
            return;
        }
        enableAnalytics();
    }, []);
    return <AnalyticsConsentBanner acceptFunction={handleEnableAnalytics} rejectFunction={() => { }} />;
}